import { Component } from '@angular/core';

@Component({
  selector: 'app-s-loader',
  templateUrl: './s-loader.component.html',
  styleUrls: ['./s-loader.component.scss']
})
export class SLoaderComponent {

}
